import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/55d8a1fb/src/components/layout.js";
import Layout from "../../components/layout";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Sorry to say, you may not be covered.`}</h2>
    <p>{`For more information about the bill, here's how it breaks down:`}</p>
    <p>{`People covered under the bill if they meet the following requirements.`}</p>
    <ul>
      <li parentName="ul">{`Not affordable housing`}</li>
      <li parentName="ul">{`Not dormitories from a higher ed institution`}</li>
      <li parentName="ul">{`Not under some other form of rent control from public entity`}</li>
      <li parentName="ul">{`Occupancy certification > 15y`}</li>
      <li parentName="ul">{`Is a condo (Residential real property that is alienable separate from the title to any other dwelling unit) unless:`}<ul parentName="li">
          <li parentName="ul">{`Unless owned by:`}<ul parentName="li">
              <li parentName="ul">{`A real estate investment trust, as defined in Section 856 of the Internal Revenue Code.`}</li>
              <li parentName="ul">{`A corporation`}</li>
              <li parentName="ul">{`An LLC in which at least one member is a corporation`}</li>
            </ul></li>
          <li parentName="ul">{`AND you got a notice that your landlord is making you exempt`}</li>
        </ul></li>
    </ul>
    <p>{`If you live in a Duplex, it must not be a Duplex in which the owner lived in (and continues to live in) one of the units at the start of your tenancy`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      